import React from "react"

import ProjectSession from "../../model2/project/project-session"
import {Copy_Manager} from "./model/manager"
import ModalCopy from "./components/modal"
import Goal from "../../model2/goal/goal"
import Task from "../../model2/task/task"
import {ModalCopy_Params} from "./@types"
import {CopyProject_Manager} from "./model/copy-project-manager"
import {CopyTemplate_Manager} from "./model/copy-template-manager"
import {CopyGoal_Manager} from "./model/copy-goal-manager"
import {CopyTask_Manager} from "./model/copy-task-manager"
import {CopyTasks_Manager} from "./model/copy-tasks-manager";

function modalCopy(manager: Copy_Manager, params?: ModalCopy_Params) {
    gd.modal.showV5(
        <ModalCopy manager={manager}/>,
        {
            toggleCallback: params?.toggleCallback
        }
    )
}

export function modalCopyProject(project:ProjectSession, params?: ModalCopy_Params) {
    const manager = !project.isTemplate ?
        new CopyProject_Manager(project, params)
        :
        new CopyTemplate_Manager(project, params)

    modalCopy(manager, params)
}

export function modalCopyGoal(goal:Goal, params?: ModalCopy_Params) {
    const manager = new CopyGoal_Manager(goal)
    modalCopy(manager, params)
}

export function modalCopyTask(task:Task, params?: ModalCopy_Params) {
    const manager = new CopyTask_Manager(task, params)
    modalCopy(manager, params)
}

export function modalCopyTasks(tasks:Task[], params?: ModalCopy_Params) {
    const manager = new CopyTasks_Manager(tasks, params)
    modalCopy(manager, params)
}